
import React from "react";
import "../SecurityPlatforms.css";
import {
  BrowserRouter as Router, Link,
  useLocation
} from "react-router-dom";
import MenuNavbar from "../../MenuNavbar";
import Floaticons from "../../Floaticons";
import Tabs from "@mui/material/Tabs";
import PropTypes from "prop-types";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import IdentiyAccessManagement from "../IdentityManagement/IdentityandAccessManagement";
import InfrastructureSecurity from "../InfrastructureSecurity/InfrastructureSecurity";
import PlatformSecurity from "../PlatformSecurity/PlatformSecurity";
import CloudSecurity from "../CloudSecurity/CloudSecurity";
import LinkTag from "@mui/material/Link";
import HomeIcon from "@mui/icons-material/Home";
import { Breadcrumbs } from "@material-ui/core";


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 4 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function SecurityPlatforms(props) {
  const [value, setValue] = React.useState(2);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const goBack = (Value) => {
    props.successCallBackData(Value)
    
  };
  return (
    <>
      <div className="banner-container">
        <img
          src="images/SecuritySchools/SailPoint/school-banner.png"
          alt="banner"
          className="banner-img"
        />
        <div className="breadcrumbs-container">
          <Breadcrumbs separator=">" color="#fff">
            <LinkTag
              underline="hover"
              sx={{ display: "flex", alignItems: "center" }}
              color="#fff"
              href="/"
            >
              <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
            </LinkTag>
            ,
            <LinkTag
              underline="hover"
              key="2"
              color="#fff"
              href="/securityLearningFramework"
              // onClick={handleClick}
            >
              Security Learning Framework
            </LinkTag>
            ,
            <Typography key="3" color="#fff">
              Security Schools
            </Typography>
            ,
          </Breadcrumbs>
        </div>
        <div className="banner-content">
          <h1>Security Schools</h1>
          <i>
            Lorem ipsum is a dummy text of the printing and typesetting industry
          </i>
        </div>
        <MenuNavbar />
      </div>
      <Floaticons />
      <div className="breadcrumbLinks">
        <Breadcrumbs separator=">" aria-label="breadcrumb">
          <a className="menu_title" href="/securitySchools">
            <img src="/images/SecuritySchools/Back-button.png" />
            Security Schools and Bootcamps​
          </a>
          {value === 0 ? (
             <Link
             className="menu_title"
             to={{
               pathname: "/securitySchools",
               state:{tabID:'I&Dmanagement'}
           }}
         >
           Identity & Access Management
         </Link>
            // <a className="menu_title" href="/securitySchools#I&DInitiatives">
            //   Identity & Access Management
            // </a>
          ) : (
            ""
          )}
          {value === 1 ? (
             <Link
             className="menu_title"
             to={{
               pathname: "/securitySchools",
               state:{tabID:'Infrastructure'}
           }}
         >
           Infrastructure Security
         </Link>
            // <a className="menu_title" href="/securitySchools#InfrastructureSecurity">
            //   Infrastructure Security
            // </a>
          ) : (
            ""
          )}
          {value === 2 ? (
            <Link
              className="menu_title"
              to={{
                pathname: "/securitySchools",
                state:{tabID:'platformSecurity'}
            }}
          >
            Platform Security 
          </Link>
          ) : (
            ""
          )}
          {value === 3 ? (
            <Link
                className="menu_title"
                to={{
                  pathname: "/securitySchools",
                  state:{tabID:'cloudsecurity'}
              }}
            >
              Cloud Security
            </Link>
            // <a className="menu_title" href="/securitySchools#cloudsecurity">
            //   Cloud Security
            // </a>
          ) : (
            ""
          )}
          <a className="menu_title" href="">
            Salesforce Security​
          </a>
        </Breadcrumbs>
      </div>
      <div className="main-container">
        <Box className="boxStyles">
          <Box
            sx={{ borderBottom: 0, borderColor: "divider" }}
            className="tabMenuWrap"
          >
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              centered
            >
              <Tab
                label="Identity & Access Management​"
                {...a11yProps(0)}
                className="tabStyles"
              />
              <Tab
                label="Infrastructure Security"
                {...a11yProps(1)}
                className="tabStyles"
              />
              <Tab
                label="Platform Security"
                {...a11yProps(2)}
                className="tabStyles"
              />
              <Tab
                label="Cloud Security"
                {...a11yProps(3)}
                className="tabStyles"
                // href='https://atci.lkm.delivery.accenture.com/ProfessionalSkills/' target='_blank'
              />
            </Tabs>
          </Box>
          <TabPanel className="tabPanelWrap" value={value} index={0}>
            <IdentiyAccessManagement />
          </TabPanel>
          <TabPanel className="tabPanelWrap" value={value} index={1}>
            <InfrastructureSecurity />
          </TabPanel>
          <TabPanel className="tabPanelWrap" value={value} index={2}>
            <div className="SP-AboutWrapp">
              <div className="leftImage">
                <img
                  src="images/SecuritySchools/SecurityPlatforms/About.png"
                  alt=""
                  className="img-responsive"
                />
              </div>
              <div className="rightContent">
                <h2 className="SP-AboutHeading">
                  About the Security Platforms<br></br>
                  <span>Salesforce Security Training</span>
                </h2>
                <p>
                  Salesforce training trains security resources in Salesforce
                  Security, Ongoing monitoring skills and Now/Workday Security.
                </p>
              </div>
            </div>
            <h2 className="key-obj-heading">Key Objectives:</h2>
            <div className="obj-inner-row">
              <div className="objectiveBox">
                <img
                  src="images/SecuritySchools/SecurityPlatforms/01-Importance-of-SaaS-Security.png"
                  alt="key-objectives-icon"
                />
                <p>Importance of SaaS Security​</p>
              </div>
              <div className="objectiveBox">
                <img
                  src="images/SecuritySchools/SecurityPlatforms/02-Installation-of-AppOmni.png"
                  alt="key-objectives-icon"
                />
                <p>
                  Installation of AppOmni, Key Risk Insights Demo, Policy
                  Review​​
                </p>
              </div>
              <div className="objectiveBox">
                <img
                  src="images/SecuritySchools/SecurityPlatforms/03-Salesforce-sheild.png"
                  alt="key-objectives-icon"
                />
                <p>
                  Sharing, GDPR, Salesforce Shield, Encryption Gateways, Event
                  Monitoring​​
                </p>
              </div>
              <div className="objectiveBox">
                <img
                  src="images/SecuritySchools/SecurityPlatforms/04-Code.png"
                  alt="key-objectives-icon"
                />
                <p>
                  Guest User Access Coding Tactics, SOQL injections, other
                  attacks such as code exploits​​
                </p>
              </div>
              <div className="objectiveBox">
                <img
                  src="images/SecuritySchools/SecurityPlatforms/05-SSRA.png"
                  alt="key-objectives-icon"
                />
                <p>
                  Show team live analysis for a current SSRA of a Top USA
                  Telecom. Firm​​
                </p>
              </div>
              <div className="objectiveBox">
                <img
                  src="images/SecuritySchools/SecurityPlatforms/06-Service-now.png"
                  alt="key-objectives-icon"
                />
                <p>Overview on other SaaS products like ServiceNow, Workday​</p>
              </div>
              <div className="objectiveBox">
                <img
                  src="images/SecuritySchools/SecurityPlatforms/07-Web-testing.png"
                  alt="key-objectives-icon"
                />
                <p>
                  Secure Code testing, Web Testing and Penetration Testing​​
                </p>
              </div>
            </div>
            <div className="topics-Wrapp">
              <h2 className="topics-heading">Topics in focus</h2>

              <div className="topics-Row1">
                <div className="arrowBox-heading">
                  Salesforce Security Training
                </div>
                <div className="topics-list">
                  <ul>
                    <li>SaaS Security Overview</li>
                    <li>Data Protection</li>
                    <li>Other SaaS Security Products</li>
                    <li>Vulnerability Demo</li>
                    <li>Secure Development</li>
                    <li>Salesforce SAST</li>
                    <li>AppOmni Exploration</li>
                    <li>Hands-On SSRA</li>
                    <li>Salesforce DAST</li>
                    <li>Risk Management</li>
                    <li>Ongoing Monitoring</li>
                    <li>Salesforce PT2</li>
                  </ul>
                </div>
                <div className="bottomCorner">
                  <img
                    src="images/SecuritySchools/SecurityPlatforms/bottom-BG.png"
                    className="img-responsive"
                    alt=""
                  />
                </div>
              </div>
              <div className="row1-bottom-section">
                <div>
                  <p className="border-Heading">
                    <span>Total Duration: 25 hours, spanned over 3 weeks</span>
                    <img
                      src="images/SecuritySchools/SecurityPlatforms/arrow.png"
                      alt=""
                    />
                  </p>
                  <p>
                    <span className="bold">Training model :</span> <br></br>
                    <span className="light">Classroom + VILT</span>​
                  </p>
                </div>
              </div>
            </div>
          </TabPanel>
          <TabPanel className="tabPanelWrap" value={value} index={3}>
            <CloudSecurity />
          </TabPanel>
        </Box>
      </div>
    </>
  );
}

export default SecurityPlatforms;

